import { FC } from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { ActionLinkButton } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const BenefitValueDescription: FC = () => {
  const onLinkClick = () => window.open("https://www4.skatteverket.se/rattsligvagledning/1323.html", "_blank");
  return (
    <>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Benefit.BenefitValueDescriptionPart1)}{" "}
      <ActionLinkButton onClick={onLinkClick}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Benefit.BenefitValueDescriptionLink)}
      </ActionLinkButton>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Benefit.BenefitValueDescriptionPart2)}
    </>
  );
};

export default BenefitValueDescription;
